import React from 'react';
import {render} from 'react-dom';
import ArticleStore from 'cms/faqs/Article/store';
import Layout from 'cms/helpers/Layout';
import Page from 'cms/faqs/Article/Page';
import {cms} from 'helpers/stableValues';
import {faqCommonTranslations, faqTranslations} from 'cms/helpers/translations';

const articleStore = new ArticleStore(
  cms,
  {...faqCommonTranslations, ...faqTranslations}
);

render((
  <Layout>
    <Page store={articleStore} />
  </Layout>), document.getElementById('cms')
);
